import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const PayCorrectionHeader: React.FC<{
  chartType: React.ReactNode;
  biasType: React.ReactNode;
  calibrationFraming: CalibrationFraming;
}> = ({ chartType, biasType, calibrationFraming }) => {
  const language = useLanguage();

  return (
    <Spacing
      direction="horizontal"
      size="sm"
      className="w-full justify-center relative"
    >
      <Spacing direction="vertical" size="sm">
        <S2Typography
          variant="headline-3-alt"
          translatedContent={language.payCorrectionCalibrationHeading({
            calibrationFraming,
          })}
        />

        <div className="flex justify-center">{biasType}</div>
      </Spacing>

      <div className="absolute top-0 right-0">{chartType}</div>
    </Spacing>
  );
};
